import type { SupportContent } from "../content/types";

type FaqListProps = {
  title: string;
  items: SupportContent["faqs"];
};

export function FaqList({ title, items }: FaqListProps) {
  return (
    <section className="support-section support-faq-section" aria-labelledby="faq-title">
      <h2 id="faq-title">{title}</h2>
      <div className="faq-list">
        {items.map((item) => (
          <article className="faq-item" key={item.question}>
            <h3>{item.question}</h3>
            <p>{item.answer}</p>
          </article>
        ))}
      </div>
    </section>
  );
}
